const buttonCategory = document.querySelector('.js-menu-category');

buttonCategory.addEventListener('click', (e) => {
    e.stopPropagation(); // Prevenir que se cierre de inmediato
    const subMenu = document.querySelector('.js-menu-content');
    const arrow = document.querySelector('.js-arrow-menu-category');
    const contentView = document.querySelector('.js-menu-content-view');

    const isOpen = subMenu.classList.contains('category-menu-content-open');

    // Alternar estado
    subMenu.classList.toggle('category-menu-content-open', !isOpen);
    contentView.classList.toggle('category-menu-content_view-active', !isOpen);
    arrow.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(90deg)';
});

// Función para actualizar título dinámicamente
const viewCategoryTitle = (title) => {
    const container = document.querySelector('.js-menu-content-view');
    const titleContent = container.querySelector('.js-menu-content-view__title');
    titleContent.innerText = title;
};

// Función para manejar interacción de los links
const linksFunction = () => {
    const allLinks = document.querySelectorAll('.js-menu-each-link');
    const allContents = document.querySelectorAll('.js-each-sub');

    if (allLinks.length === 0 || allContents.length === 0) return;

    viewCategoryTitle(allLinks[0].dataset.title);
    allContents[0].classList.add('each-content-active');

    allLinks.forEach((link) => {
        const activateLink = () => {
            viewCategoryTitle(link.dataset.title);

            allContents.forEach((each) => {
                each.classList.toggle('each-content-active', each.dataset.title === link.dataset.title);
            });

            allLinks.forEach((eachLink) => eachLink.classList.remove('category-menu-content__box-link-active'));
            link.classList.add('category-menu-content__box-link-active');
        };

        // Detectar si es móvil o escritorio
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        if (isTouchDevice) {
            link.addEventListener('click', activateLink); // Tap en móviles
        } else {
            link.addEventListener('mouseover', activateLink); // Hover en desktop
        }
    });
};
linksFunction();

// Cerrar el menú si haces clic afuera
document.addEventListener('click', (e) => {
    const subMenu = document.querySelector('.js-menu-content');
    const contentView = document.querySelector('.js-menu-content-view');
    const arrow = document.querySelector('.js-arrow-menu-category');

    if (subMenu.classList.contains('category-menu-content-open')) {
        // Si haces clic fuera del menú
        if (!e.target.closest('.js-menu-content') && !e.target.closest('.js-menu-category')) {
            subMenu.classList.remove('category-menu-content-open');
            contentView.classList.remove('category-menu-content_view-active');
            arrow.style.transform = 'rotate(0deg)';
        }
    }
});




